// extracted by mini-css-extract-plugin
export default {"listItem":"lhYDs8bDiXf5sCrsipRE","list":"gLU9Hu2rDpRJmzaMJm7g"};